import React from 'react'
import './SideNav.css'
import { BsCalendar, BsFileBarGraph, BsPen, BsPerson } from 'react-icons/bs'
import { BiChevronLeft, BiChevronRight, BiLogOutCircle, BiMoney } from 'react-icons/bi'
import { IoTicketOutline } from 'react-icons/io5'
import { NavLink } from 'react-router-dom'
import { API_URL } from '../config'

const NAV_ITEMS = [
  {
    section: 'WORKSPACE',
    items: [
      { label: 'Dashboard', icon: <BsFileBarGraph />, to: '/customerdashboard' },
      { label: 'Events', icon: <BsCalendar />, to: '/' },
      { label: 'Tickets', icon: <IoTicketOutline />, to: '/tickets' },
      { label: 'Transactions', icon: <BiMoney />, to: '/transactions-view' },
      { label: 'Feedback', icon: <BsPen />, to: '/feedback' },
    ],
  },
  {
    section: 'ACCOUNT',
    items: [{ label: 'My Account', icon: <BsPerson />, to: '/profile' }],
  },
]

const SideNavCust = ({ collapsed = false, onToggle, onNavigate }) => {
  const handleLogout = async () => {
    try {
      await fetch(`${API_URL}/apps/kscanner/logout.php`, {
        method: 'GET',
        credentials: 'include',
      })
    } catch (error) {
      console.error('Logout request failed:', error)
    } finally {
      localStorage.clear()
      window.location.href = '/login'
    }
  }

  const handleNavigate = () => {
    if (onNavigate) onNavigate()
  }

  return (
    <aside className={`kx-sidenav ${collapsed ? 'is-collapsed' : ''}`}>
      <div className="kx-sidenav__top">
        <div className="kx-sidenav__control-row">
          {!collapsed && <span className="kx-sidenav__eyebrow">MENU</span>}

          <button
            type="button"
            className="kx-sidenav__toggle"
            onClick={onToggle}
            aria-label={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
            title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          >
            {collapsed ? <BiChevronRight /> : <BiChevronLeft />}
          </button>
        </div>

        <nav className="kx-sidenav__navigation" aria-label="Main navigation">
          {NAV_ITEMS.map((section) => (
            <div className="kx-sidenav__section" key={section.section}>
              {!collapsed && <div className="kx-sidenav__section-label">{section.section}</div>}

              <ul className="kx-sidenav__list">
                {section.items.map(({ to, label, icon }) => (
                  <li className="kx-sidenav__item" key={to}>
                    <NavLink
                      to={to}
                      exact
                      activeClassName="is-active"
                      className="kx-sidenav__link"
                      onClick={handleNavigate}
                      title={collapsed ? label : undefined}
                    >
                      <span className="kx-sidenav__icon" aria-hidden="true">
                        {icon}
                      </span>
                      {!collapsed && <span className="kx-sidenav__label">{label}</span>}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </nav>
      </div>

      <div className="kx-sidenav__bottom">
        <button
          type="button"
          className="kx-sidenav__link kx-sidenav__logout"
          onClick={handleLogout}
          title={collapsed ? 'Logout' : undefined}
        >
          <span className="kx-sidenav__icon" aria-hidden="true">
            <BiLogOutCircle />
          </span>
          {!collapsed && <span className="kx-sidenav__label">Logout</span>}
        </button>

        {!collapsed && (
          <div className="kx-sidenav__footer">
            <span className="kx-sidenav__footer-dot" />
            <span>Karamale Attendee</span>
          </div>
        )}
      </div>
    </aside>
  )
}

export default SideNavCust
